import { useEffect, useState } from 'react';
import {
  getCurrentPicking,
  getActiveRoutes,
  getShortedItems,
  getPickerPerformance,
  CurrentPicking,
  ActiveRoute,
  ShortedItem,
  PickerPerformance,
} from '../../../components/api/picking';

const buildFullName = (first?: string | null, last?: string | null) => `${first || ''} ${last || ''}`.trim() || null;

const computeItemsPerHour = (itemsPicked?: number | null, secondsWorked?: number | null) => {
  if (!itemsPicked || !secondsWorked || secondsWorked <= 0) return 0;
  const hours = secondsWorked / 3600;
  return hours > 0 ? itemsPicked / hours : 0;
};

export default function useVendingPickingDashboard() {
  const [currentPicking, setCurrentPicking] = useState<CurrentPicking | null>(null);
  const [routes, setRoutes] = useState<ActiveRoute[]>([]);
  const [shortedItems, setShortedItemsState] = useState<ShortedItem[]>([]);
  const [pickerStats, setPickerStats] = useState<(PickerPerformance & { pickerName: string | null; itemsPerHour: number })[]>([]);
  const [selectedPickerId, setSelectedPickerId] = useState<string>('');

  useEffect(() => {
    // Current picking
    getCurrentPicking()
      .then((res) => {
        const list = res.data.data || [];
        setCurrentPicking(list.length > 0 ? list[0] : null);
      })
      .catch(() => {
        setCurrentPicking(null);
      });

    // Active routes
    getActiveRoutes()
      .then((res) => {
        setRoutes(res.data.data || []);
      })
      .catch(() => {
        setRoutes([]);
      });

    // Shorted items
    getShortedItems()
      .then((res) => {
        setShortedItemsState(res.data.data || []);
      })
      .catch(() => {
        setShortedItemsState([]);
      });

    // Picker performance
    getPickerPerformance()
      .then((res) => {
        const list = res.data.data || [];
        const withDerived = list.map((p) => ({
          ...p,
          pickerName: buildFullName(p.pickerFirstName, p.pickerLastName),
          itemsPerHour: computeItemsPerHour(p.itemsPicked, p.secondsWorked),
        }));

        setPickerStats(withDerived);

        if (!selectedPickerId && withDerived.length > 0) {
          setSelectedPickerId(String(withDerived[0].pickerUserId));
        }
      })
      .catch(() => {
        setPickerStats([]);
      });
  }, [selectedPickerId]);

  return {
    currentPicking,
    routes,
    shortedItems,
    pickerStats,
    selectedPickerId,
    setSelectedPickerId,
  };
}
